const DIALOG_VIEWPORT_MARGIN = 60
const MAX_DIALOG_WIDTH = 1380

export const getTutorialDialogSize = () => ({
  width: Math.min(window.innerWidth - DIALOG_VIEWPORT_MARGIN, MAX_DIALOG_WIDTH),
  height: window.innerHeight - DIALOG_VIEWPORT_MARGIN,
})
